import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsResult,
  BulkActionsStep,
} from "components/BulkActions/types";
import { Stack } from "components/icons/generated";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import Link from "ds/components/Link";

import { StackRunEntity } from "../types";

type RunsBulkActionsResultItemProps = {
  item: StackRunEntity;
  tab: BulkActionResultTabs;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const RunsBulkActionsResultItem = ({
  item,
  tab,
  resultsMetadata,
  status,
  stopExecution,
}: RunsBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={item.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <Box direction="column" gap="small" fullWidth>
          <Box align="center" gap="small" fullWidth>
            <BulkActionsDrawerItemStatusIcon result={status} />
            <BulkActionsDrawerItemLink
              link={`/stack/${item.stack.id}/run/${item.id}`}
              text={item.title}
              step={BulkActionsStep.Results}
              itemCategory={tab}
            />
          </Box>
          <Link href={`/stack/${item.stack.id}`} size="small" startIcon={Stack}>
            {item.stack.name}
          </Link>
        </Box>
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(item.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(item.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default RunsBulkActionsResultItem;
